import React, { useMemo, useState } from "react";
import {
  Card,
  DataTable,
  Text,
  BlockStack,
  Button,
  Modal,
  Badge,
  TextField,
} from "@shopify/polaris";

const CouponTable = ({ products, indexing = 1, perPage, search, setSearch }) => {
  const [activeProduct, setActiveProduct] = useState(null);
  const [activeInvoice, setActiveInvoice] = useState(null);
  const [activeSlogan, setActiveSlogan] = useState(null);
  const getDecimalValue = (value) => {
    if (value && typeof value === "object" && value.$numberDecimal) {
      return value.$numberDecimal;
    }

    return value || "0";
  };
  const filteredProduct = useMemo(() => {
    return products.filter((item) =>
      item?.couponcode?.toLowerCase().includes(search.toLowerCase()),
    );
  },[products,search]);
  const rows =
    filteredProduct?.map((item, index) => [
      index + 1 + (indexing - 1) * perPage,
      item.name || "—",
      item.phone || "—",
      item.product || "_",
      item.city || "_",
      item.couponcode || "_",
      new Date(item.createdAt).toLocaleDateString(),
    ]) || [];

  const headings = [
    "SN",
    "Name",
    "Phone",
    "Product",
    "City",
    "Coupon Code",
    "Date",
  ];

  return (
    <>
      <Card>
        <BlockStack gap="400">
          <TextField
            label="Search Coupon Code"
            value={search}
            onChange={setSearch}
            autoComplete="off"
            placeholder="Enter coupon code..."
          />

          <DataTable
            columnContentTypes={headings.map((r) =>
              r === "SN" ? "numeric" : "text",
            )}
            headings={headings}
            rows={rows}
          />
        </BlockStack>
      </Card>
    </>
  );
};

export default CouponTable;
